export default __webpack_public_path__ + "static/media/403.95864297.png";